import { useState, useCallback } from 'react';
import { portfolioApi } from '../api';

const formatError = (err) => {
  const data = err.data;
  if (data?.message && data?.code) {
    return { code: data.code, message: data.message };
  }
  return { code: null, message: err.message || 'Đã xảy ra lỗi' };
};

export default function usePortfolio() {
  const [portfolios, setPortfolios] = useState([]);
  const [selectedPortfolioId, setSelectedPortfolioId] = useState(null);
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [syncing, setSyncing] = useState(false);

  const initialize = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await portfolioApi.getPortfolios();
      const list = res.data || [];
      setPortfolios(list);
      if (list.length > 0) {
        const firstId = list[0].id;
        setSelectedPortfolioId(firstId);
        const posRes = await portfolioApi.getPositions(firstId);
        setPositions(posRes.data || []);
      }
    } catch (err) {
      setError(formatError(err));
    } finally {
      setLoading(false);
    }
  }, []);

  const selectPortfolio = useCallback(async (portfolioId) => {
    setSelectedPortfolioId(portfolioId);
    setLoading(true);
    setError(null);
    try {
      const res = await portfolioApi.getPositions(portfolioId);
      setPositions(res.data || []);
    } catch (err) {
      setError(formatError(err));
    } finally {
      setLoading(false);
    }
  }, []);

  const syncPositions = useCallback(async (userId) => {
    setSyncing(true);
    setError(null);
    try {
      await portfolioApi.syncPositions(userId);
      const res = await portfolioApi.getPortfolios();
      const list = res.data || [];
      setPortfolios(list);
      const activeId = list.find((p) => p.id === selectedPortfolioId)?.id || list[0]?.id;
      if (activeId) {
        setSelectedPortfolioId(activeId);
        const posRes = await portfolioApi.getPositions(activeId);
        setPositions(posRes.data || []);
      }
    } catch (err) {
      setError(formatError(err));
    } finally {
      setSyncing(false);
    }
  }, [selectedPortfolioId]);

  const clearError = useCallback(() => setError(null), []);

  return {
    portfolios,
    selectedPortfolioId,
    positions,
    loading,
    syncing,
    error,
    initialize,
    selectPortfolio,
    syncPositions,
    clearError,
  };
}
